import React, { useState } from 'react'

interface IProps {
    onChange: (groupId: string) => void;
    label: string;
}

export const EventTypeFilter = ({ onChange, label }: IProps) => {
    const list = [
        { value: 'all', name: 'All' }, 
        { value: 'verified_plaid_success', name: 'PLAID Verification Success' },
        { value: 'verified_plaid_failed', name: 'PLAID Verification Failed' },
        { value: 'uploaded_workid', name: 'Uploaded workID' },
        { value: 'registered_pending', name: 'User registered' }
    ];
    const [itemSelected, setItemSelected] = useState<any>('');
  
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      const value = e.target.value;
        onChange(value);
        setItemSelected(value);
    }
  
    return (
      <div>
        <div>
          <span className="text-muted">{label}:</span>
        </div>
        <select 
            className={`form-control`}
            name="Event types"
            style={{ width: '220px' }}
            onChange={handleChange}
            value={itemSelected || ''}
        >
            {
                list.map((item, index) => (
                    <option key={index} value={item.value}>{item.name}</option>
                ))
            }
        </select>
      </div>
    );
  }
